// extracted by extract-css-chunks-webpack-plugin
module.exports = {"fullWidthMobile":"_3Y39xx","universalProductTableTitle":"_3Nzzvf"};